export class Events {
  public ID!: number;
  public EVENT_NAME!: string;
  public EVENT_DATE!: string;
  public EVENT_END_DATE!: string;
  public EVENT_TYPE!: number;
  public EVENT_DESCRIPTION!: string;
  public EVENT_SHORT_MESSAGE!: string;
  public EVENT_CONTENT!: string;
  public ImagePath!: string;
  public CREATED_DATE!: string;
  public CREATED_BY!: number;
  public UPDATED_DATE!: string;
  public UPDATED_BY!: number;
  public IS_ACTIVE!: boolean;
}

